/**
 * Stable, prefixed, time-sortable ids for every new domain object (architecture spec
 * section 4): org_, mem_, prj_, nod_, ses_, msn_, itm_, lnd_, apr_, bud_, pol_, tok_, ntf_, grt_, pair_ (pairing requests),
 * apb_ (a batch of approval answers, ADR 0072), dlg_ (delegate policies), jt_ (join tickets, ADR 0090).
 * A 26-character Crockford base32 ULID follows the prefix. Browser-safe.
 */
export type IdPrefix = 'org' | 'mem' | 'prj' | 'nod' | 'ses' | 'msn' | 'itm' | 'lnd' | 'apr' | 'bud' | 'pol' | 'tok' | 'ntf' | 'evt' | 'lnk' | 'prp' | 'job' | 'sig' | 'seq' | 'vw' | 'grt' | 'pair' | 'apb' | 'dlg' | 'jt';

const B32 = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export function ulid(now: number = Date.now()): string {
  let t = now;
  let time = '';
  for (let i = 0; i < 10; i++) {
    time = B32[t % 32] + time;
    t = Math.floor(t / 32);
  }
  const bytes = new Uint8Array(16);
  (globalThis as unknown as { crypto: { getRandomValues(a: Uint8Array): Uint8Array } }).crypto.getRandomValues(bytes);
  let rand = '';
  for (let i = 0; i < 16; i++) rand += B32[(bytes[i] as number) % 32];
  return time + rand;
}

export function newPrefixedId(prefix: IdPrefix, now?: number): string {
  return `${prefix}_${ulid(now)}`;
}

/** The org every object belongs to while Orgus runs single-tenant. */
export const DEFAULT_ORG_ID = 'org_local';
